module.exports = __webpack_public_path__ + "static/img/3.476a9d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/3.png
// module id = h2TL
// module chunks = 0